import React from 'react';
import { Route } from 'react-router-dom';
import AktienanalyseLayout from 'modules/aktien/pages/AktienanalyseLayout';
import IndizesView from 'modules/aktien/pages/views/IndizesView';
import WatchlistsView from 'modules/aktien/pages/views/WatchlistsView';
import DepotView from 'modules/aktien/pages/views/DepotView';
import ListeDbView from 'modules/aktien/pages/views/ListeDbView';
import AktieHinzufuegenView from 'modules/aktien/pages/views/AktieHinzufuegenView';
import AktieDetailView from 'modules/aktien/pages/views/AktieDetailView';
import AktieAnalyseView from 'modules/aktien/pages/views/AktieAnalyseView';
import SchwankungenView from 'modules/aktien/pages/views/SchwankungenView';
import BerichteView from 'modules/aktien/pages/views/BerichteView';
import DebugLogPanel from 'modules/aktien/components/DebugLogPanel';
import indizesReducer from 'modules/aktien/features/indizesSlice';
import watchlistsReducer from 'modules/aktien/features/watchlistsSlice';
import depotReducer from 'modules/aktien/features/depotSlice';
import aktienDbReducer from 'modules/aktien/features/aktienDbSlice';
import schwankungenReducer from 'modules/aktien/features/schwankungenSlice';
import berichteReducer from 'modules/aktien/features/berichteSlice';
import debugLogsReducer from 'modules/aktien/features/debugLogsSlice';

/**
 * Modul-Definition "Aktienanalyse".
 *
 * Einziger Export des Moduls an das Portal (Registry in modules/index.js):
 * Metadaten für die Übersichtsseite, Routen, Redux-Reducer und optionale
 * Portal-Widgets. Interna des Moduls werden NICHT exportiert.
 */
const aktienModul = {
  id: 'aktienanalyse',
  name: 'Aktienanalyse',
  description:
    'Analyse von Aktien, Indizes und Kennzahlen auf Basis des Aktien-Moduls.',
  path: '/projekte/aktienanalyse',
  icon: '📈',
  gradient: 'from-emerald-400 to-teal-600',
  status: 'active',
  reducers: {
    indizes: indizesReducer,
    watchlists: watchlistsReducer,
    depot: depotReducer,
    aktienDb: aktienDbReducer,
    schwankungen: schwankungenReducer,
    berichte: berichteReducer,
    debugLogs: debugLogsReducer,
  },
  routes: (
    <Route path="/projekte/aktienanalyse" element={<AktienanalyseLayout />}>
      <Route index element={<IndizesView />} />
      <Route path="depot" element={<DepotView />} />
      <Route path="listen" element={<WatchlistsView />} />
      <Route path="liste" element={<ListeDbView />} />
      <Route path="hinzufuegen" element={<AktieHinzufuegenView />} />
      <Route path="aktie/:isin" element={<AktieDetailView />} />
      <Route path="analyse" element={<AktieAnalyseView />} />
      <Route path="analyse/:isin" element={<AktieAnalyseView />} />
      <Route path="schwankungen" element={<SchwankungenView />} />
      <Route path="berichte" element={<BerichteView />} />
    </Route>
  ),
  portalWidgets: [DebugLogPanel],
};

export default aktienModul;

// Öffentliche API für andere Module (bewusst klein halten):
// Kursdaten-Zugriff für den Kursverlauf-Tab im Reddit-Modul.
export {
  selectAktie,
  fetchAktieDetail,
  selectAktieDetail,
  selectAktieDetailStatus,
} from 'modules/aktien/features/aktienDbSlice';

// Depot-Werte (Live-Kurse/Gewinn) für die Aktien-Verknüpfung im Investitionen-Modul.
export { fetchDepotApi } from 'modules/aktien/features/aktienApi';
